import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import WillkommenBeiJenniferEckstein from "./sections/WillkommenBeiJenniferEckstein";
import AtmosphereInFilm from "./sections/AtmosphereInFilm";
import WarumHundetransport24 from "./sections/WarumHundetransport24";
import ForFreelancersRemoteWorkersAndTeams from "./sections/ForFreelancersRemoteWorkersAndTeams";
import ProcessTimeline from "./sections/ProcessTimeline";
import InfoColumns from "./sections/InfoColumns";
import CentrallyLocatedWithoutCityStress from "./sections/CentrallyLocatedWithoutCityStress";
import HowToFindUs from "./sections/HowToFindUs";
import PartnerAbschluss from "@/reusable_sections/Footer";
import Hero from "./sections/Hero";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <WillkommenBeiJenniferEckstein />
      <WarumHundetransport24 />
      <AtmosphereInFilm />
      <ForFreelancersRemoteWorkersAndTeams />
      <ProcessTimeline />
      <InfoColumns />
      <CentrallyLocatedWithoutCityStress />
      <HowToFindUs />
      <PartnerAbschluss />
    </div>;
}